import { render, staticRenderFns } from "./ListCreateEdit.vue?vue&type=template&id=c9c1971c&"
import script from "./ListCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ListCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports